import React from 'react';
import ReactDOM from 'react-dom';
import '../Modal/modal.css';
import ModalBody from './ModalBody';
import AcceptFeedbackModalBody from './AcceptFeedbackModalBody';
const AcceptFeedbackModal = ({ isShowing, hide, val,onClose }) => {
  // console.log(val);

  return isShowing ? (

    <React.Fragment>
      <div className="modal-overlay" />
      <div className="modal-wrapper" aria-modal aria-hidden role="dialog">
        <AcceptFeedbackModalBody open={isShowing} handleClose={hide} val={val} onClose={onClose}></AcceptFeedbackModalBody>
      </div>
    </React.Fragment>
  ) : null;
}

export default AcceptFeedbackModal;